import { valueHash } from './value-hash';

export function objectEqual(a, b): boolean {
    return valueHash(a) === valueHash(b);
}
